import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  /* display: grid; */
  /* flex-direction: column; */
  /* flex-direction: row; */
  gap: 1.5rem;

  align-items: center;
  justify-content: left;

    > div:first-child {
    flex: 1;
  }

  padding: 1rem 0 0 0;
  width: 100%;
  align-content: center;
  align-self: center;

  button {
    margin-top: 0.1rem;
    margin-bottom: 1.1rem;
    width: 40rem;
  }
`;


export const ContainerTela = styled.div`
  display: flex;
  flex-direction: column; /* Alinha as divs verticalmente */
  height: 72vh; /* Ocupa 100% da altura da viewport */
  //margin: 0; /* Remove margens */
`;

export const ContainerTela80 = styled.div`
  height: 100%; /* 80% da altura da página */
  background-color: lightblue;
`;

export const ContainerTela20 = styled.div`
  padding: 10px;
  flex-grow: 1; /* Ocupa o espaço restante (20%) */
  /* height: 20%; */
  /* background-color: lightcoral; */
`;
